"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var hooks_1 = require("preact/hooks");
var react_spring_1 = require("react-spring");
function Accordion(props) {
    var _a = (0, hooks_1.useState)(!!props.startOpen), open = _a[0], setOpen = _a[1];
    // If the User interacted with the accordion instead of startOpen
    var _b = (0, hooks_1.useState)(false), touched = _b[0], setTouched = _b[1];
    var _c = (0, hooks_1.useState)(0), contentMaxHeight = _c[0], setContentMaxHeight = _c[1];
    var ref = (0, hooks_1.useRef)(null);
    var handleClick = function () {
        setTouched(true);
        setOpen(!open);
    };
    (0, hooks_1.useEffect)(function () {
        setOpen(!!props.startOpen);
    }, []);
    (0, hooks_1.useEffect)(function () {
        var calcContentMaxHeight = function () {
            ref.current && setContentMaxHeight(ref.current.scrollHeight);
        };
        calcContentMaxHeight();
        window.addEventListener('resize', function () { return calcContentMaxHeight(); });
        return function () { return window.removeEventListener('resize', calcContentMaxHeight); };
    }, [ref, contentMaxHeight, props.body]);
    //open animation with react spring
    var openAnimation = (0, react_spring_1.useSpring)({
        opacity: open ? 1 : 0,
        maxHeight: open ? contentMaxHeight : 0,
        config: { duration: 20, tension: 120, friction: 14 },
        // immediate: !!props.startOpen
    });
    //rotate animation
    var iconAnimation = (0, react_spring_1.useSpring)({
        transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
        config: { duration: 250, tension: 120, friction: 14 },
    });
    return ((0, preact_1.h)("div", { className: "accordion-v2__item" },
        (0, preact_1.h)("div", { className: "accordion-v2__header", onClick: handleClick },
            props.title,
            (0, preact_1.h)(react_spring_1.animated.i, { className: "accordion-v2__arrow", style: iconAnimation },
                (0, preact_1.h)("img", { src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/Triangle-drop-down-menus.svg?v=1705006746" }))),
        (0, preact_1.h)(react_spring_1.animated.div, { className: touched && 'accordion-v2__content', ref: ref, style: openAnimation }, props.body)));
}
exports.default = Accordion;
